<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || _closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">{{ headText }} Security</span>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="wkn"
                    type="number"
                    label="WKN"
                    :rules="wknRules"
                    :disabled="submitBtnLabel !== &quot;Create&quot;"
                    single-line
                    box
                    required
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="isin"
                    type="number"
                    label="Isin"
                    :rules="isinRules"
                    single-line
                    box
                    required
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="financing_entity_id"
                    type="number"
                    label="Financing Entity ID"
                    :rules="financingEntityIDRules"
                    single-line
                    box
                    required
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm6
                >
                  <v-text-field
                    v-model="max_amount"
                    type="number"
                    label="Max Amount"
                    :rules="maxAmountRules"
                    single-line
                    box
                    required
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-alert
            v-if="updateError"
            :value="true"
            type="error"
            class="my-3"
          >
            {{ updateError }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="cancelAction()"
          >
            {{ cancelBtnLabel }}
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="_updateSecurity()"
          >
            {{ submitBtnLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'UpdateSecurity',
  props: {
    dialog: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    submitBtnLabel: {
      type: String,
      default: '',
    },
    cancelBtnLabel: {
      type: String,
      default: '',
    },
    headText: {
      type: String,
      default: '',
    },
    updateError: {
      type: String,
      default: '',
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      wkn: '',
      isin: '',
      financing_entity_id: '',
      max_amount: 1,
      wknRules: [
        v => !!v || 'WKN is required',
        v => /^\d+$/.test(v) || 'WKN should be number',
      ],
      isinRules: [
        v => !!v || 'Isin is required',
        v => /^\d+$/.test(v) || 'Isin should be number',
      ],
      financingEntityIDRules: [
        v => !!v || 'Financing entity ID is required',
        v => /^\d+$/.test(v) || 'Financing entity ID should be number',
      ],
      maxAmountRules: [
        v => (!!v || v === 0) || 'Max amount is required',
        v => /^\d+$/.test(v) || 'Max amount should be number',
      ],
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
    data(val) {
      this.wkn = val.wkn;
      this.isin = val.isin;
      this.financing_entity_id = val.financing_entity_id;
      this.max_amount = val.max_amount;
    },
  },
  methods: {
    _updateSecurity() {
      if (this.$refs.form.validate()) {
        this.submitAction({
          wkn: this.wkn,
          isin: this.isin,
          financing_entity_id: this.financing_entity_id,
          max_amount: this.max_amount,
        });
      }
    },
    _closeDialog() {
      this.cancelAction();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/securities/UpdateSecurity.vue